import { Card, CardBody, Col } from "reactstrap";
import PrefixForm from "./PrefixForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { PostfixFormattedLabelTitle } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const Prefix = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={PostfixFormattedLabelTitle} span={BasicSliderData} />
        <CardBody className="mt-3 mb-3">
          <PrefixForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Prefix;
